import styled from 'styled-components';

interface SpecialInputProps {
    readonly isChanged?: boolean;
    readonly isEdited?: boolean;
    readonly isError?: boolean;
}

export const OutlinedInput = styled.input`
    font-size: 14px;
    width: 100%;
    height: 30px;
    border: 1px solid #7CBE7B;
    box-sizing: border-box;
    border-radius: 5px;
    padding-left: 10px;
    margin-bottom: 20px;
`;

export const SearchInput = styled.input`
    outline: none;
    padding-left: 10px;

    font-size: 14px;
    width: 100%;
    height: 30px;
    background: #FFFFFF;
    border-radius: 5px;
`;

export const UnderlinedInput = styled.input<SpecialInputProps>`
    font-size: 14px;
    width: 100%;
    box-sizing: border-box;
    border-radius: 0;
    border-bottom: 2px solid;
    transition: 0.4s;
     border-color: ${props =>
        props.isError ? "#DB5656" : 
        props.isEdited ? "#ffa620" : 
        props.isChanged ? "#7CBE7B" : 
        "#7CBE7B"}; 
    };
`;
    
    // border-color: ${props => props["isChanged"] ?
    //     "#DB5656" : "#7CBE7B"};


